import { createCSV, formatDate, getConstantKey } from '../helpers'
import { USER_TYPE, GENDER } from '../constant'


const getUserHeadByType = (type) => {
  if (type !== USER_TYPE.PHOTOGRAPHER) {
    return [
      'EMAIL',
      'FIRST NAME',
      'LAST NAME',
      'GENDER',
      'TYPE',
      'TAGS',
      'ADDRESS',
      'REGISTRATION DATE',
      'LIKES RECEIVED / EMITED',
      'APPEARANCES',
      'MATCHES',
      'HEIGHT',
      'BUST',
      'WAIST',
      'HIPS',
      'SHOES',
      'HAIR',
      'ETHNICITY',
      'EYES',
      'GIGS',
    ]
  }

  return [
    'EMAIL',
    'FIRST NAME',
    'LAST NAME',
    'GENDER',
    'TYPE',
    'TAGS',
    'ADDRESS',
    'REGISTRATION DATE',
    'LIKES RECEIVED / EMITED',
    'APPEARANCES',
    'MATCHES',
  ]
}


const getUserRowByType = (user) => {
  const gender = getConstantKey(GENDER, user.gender) || 'UNKNOWN'
  const type = getConstantKey(USER_TYPE, user.type) || 'UNKNOWN'
  const tags = (user.tags || []).join('; ')

  if (user.type !== USER_TYPE.PHOTOGRAPHER) {
    return [
      user.email,
      user.firstname,
      user.lastname,
      gender,
      type,
      tags,
      user.address ? `${user.address_city}; ${user.address_country}` : '',
      formatDate(user.created_at),
      `${user.likes} / ${user.liked}`,
      user.appearance || 0,
      user.matches || 0,
      (user.characteristics && user.characteristics.height) || '',
      (user.characteristics && user.characteristics.bust) || '',
      (user.characteristics && user.characteristics.waist) || '',
      (user.characteristics && user.characteristics.hips) || '',
      (user.characteristics && user.characteristics.shoes) || '',
      (user.characteristics && user.characteristics.hair) || '',
      (user.characteristics && user.characteristics.ethnicity) || '',
      (user.characteristics && user.characteristics.eyes) || '',
      (user.characteristics && user.characteristics.gigs) || '',
    ]
  }

  return [
    user.email,
    user.firstname,
    user.lastname,
    gender,
    type,
    tags,
    user.address ? `${user.address_city}, ${user.address_country}` : '',
    formatDate(user.created_at),
    `${user.likes} / ${user.liked}`,
    user.appearance || 0,
    user.matches || 0,
  ]
}

export const csvUsers = (users, type = USER_TYPE.ALL, title = 'users') => {
  createCSV(getUserHeadByType(type), users.map(getUserRowByType), title)
}

export const csvCastings = (castings, title = 'castings') => {
  createCSV(
    ['NAME', 'BRAND', 'EMAIL', 'TYPE', 'CREATED AT'],
    castings.map(casting => ([
      casting.name,
      casting.brand || '',
      casting.email,
      getConstantKey(USER_TYPE, casting.type) || 'UNKNOWN',
      formatDate(casting.created_at),
    ])),
    title,
  )
}

export const csvCastingProfiles = (profiles, title = 'casting_profiles') => {
  createCSV(
    ['EMAIL', 'FIRST NAME', 'LAST NAME', 'GENDER', 'TYPE', 'STATUS'],
    profiles.map(profile => ([
      profile.email,
      profile.firstname,
      profile.lastname,
      getConstantKey(GENDER, profile.gender),
      getConstantKey(USER_TYPE, profile.type),
      profile.validation_status,
    ])),
    title,
  )
}
